import { useRouter } from "@tanstack/react-router";
import { Moon, Sun } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { getThemeIsomorphic } from "@/lib/utils/get-theme";
import { Button } from "@/components/ui/button";

export function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useState("dark");
  const router = useRouter();

  const toggleTheme = useCallback(async () => {
    const theme = await getThemeIsomorphic();
    document.cookie = `theme=${theme === "light" ? "dark" : "light"}; path=/`;
    router.invalidate();
  }, [router]);

  useEffect(() => {
    getThemeIsomorphic().then(setTheme);
  }, []);

  return (
    <Button variant="outline" onClick={toggleTheme} className={cn("p-2 h-auto", className)}>
      {theme === "dark" ? <Sun /> : <Moon />}
    </Button>
  );
}
